import GiftWall from '~/pages/GiftWall/pages/index/reducers'
import GiftWallRank from '../pages/GiftWall/pages/rank/reducers'

export default {
  GiftWall,
  GiftWallRank,
}
